<template>
  <div>
    <patient-info/>
    <connect-patient
      v-if="icConnected"
      :connect-data="connectedData"
    />
    <div class="patient-help">
      <div class="patient-title">
        <span class="title">急救信息</span>
      </div>
      <div class="patient-method single-row">
        <span class="key">初诊：</span>
        <el-input v-model="fillInfo.first_visit" class="value"/>
      </div>
      <div class="patient-method single-row">
        <span class="key">病情分级：</span>
        <four-level :level="fillInfo.level" @setNewLevel="handleClickLevel"/>

      </div>
      <div class="patient-method long-row">
        <span class="key">病情描述：</span>
        <el-input
          v-model="fillInfo.desc"
          class="value"
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
        />
      </div>
      <div class="patient-method long-row">
        <span class="key">急救措施：</span>
        <el-input
          v-model="fillInfo.measure"
          class="value"
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
        />
      </div>
      <div class="patient-method long-row">
        <span class="key">院内预备：</span>
        <el-input
          v-model="fillInfo.preparation"
          class="value"
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
        />
      </div>
    </div>
    <div>
      <el-button class="confirm-button" @click="saveDrawer">保存</el-button>
    </div>
  </div>
</template>

<script>
import PatientInfo from "@/components/Drawers/Live/PatientInfo";
import ConnectPatient from "@/components/Drawers/Live/ConnectPatient";
import { getLiveInformation, saveLiveInformation } from "@api/record";
import { showWindowMessage } from "@utils/notification";
import FourLevel from "@components/common/FourLevel";

export default {
  name: "Record",
  components: {
    FourLevel,
    PatientInfo,
    ConnectPatient
  },
  props: {
    patient: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      icConnected: true,
      connectedData: {
        allergy: [
          // "花粉", "布洛芬"
        ],
        latest: [
          // "1, 广州某医院, 看病完毕. 又看了好几次, 没啥大问题.",
          // "2, 北京某医院, 看病完毕. 又看了好几次, 没啥大问题. 但是吧, 后来好像又有点问题!"
        ],
      },
      timer: null,
      timer2: null,
      allEmpty: true,
      fillInfo: {
        first_visit: "", // 初诊
        desc: "",
        measure: "",
        preparation: "",
        level: "",
        id: ""
      }
    };
  },
  watch: {
    fillInfo: {
      handler(form) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
          clearTimeout(this.timer2);
          this.timer2 = null;
        }
        this.timer = setTimeout(() => {
          localStorage.setItem("liveRecord", JSON.stringify(this.fillInfo));
          this.timer2 = setTimeout(() => {
            if (this.allEmpty) {
              this.saveDrawer();
            }
            // }, 1000 * 60);
          }, 1000 * 60 * 10);
          // }, 1000 * 10);
        }, 1000 * 60 * 3);
      },
      deep: true
    },
  },
  mounted() {
    this.getInformation();
    const lastData = sessionStorage.getItem("liveRecord");
    if (lastData) {
      this.fillInfo = JSON.parse(lastData);
    }
  },
  beforeUnmount() {
    localStorage.removeItem("liveRecord");
  },
  methods: {
    /**
     * 进来就获得基本数据
     * */
    async getInformation() {
      try {
        const { code, data, msg } = await getLiveInformation(this.patient.id);
        this.rawData = JSON.stringify(data);
        // console.log(data);
        if (code !== 200) {
          showWindowMessage(3, msg, this);
          return;
        }
        const { details, fistCheck, illness_level, operationM, prepare, id } = data;
        this.allEmpty = !details && !fistCheck && !illness_level && !operationM && !prepare; // 判断以前是否有数据
        this.fillInfo = {
          first_visit: fistCheck,
          desc: details,
          measure: operationM,
          preparation: prepare,
          level: illness_level,
          id
        };
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    /**
     * 保存急救记录/
     * */
    async saveDrawer() {
      this.fillInfo.id = this.patient.id;
      try {
        const { msg, code } = await saveLiveInformation(this.fillInfo);
        showWindowMessage(code === 200 ? 4 : 3, msg, this);
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    /**
     * 点击病情分级
     * @param {string} e -  primary, success, info, warning
     * */
    handleClickLevel(e) {
      this.fillInfo.level = e;
    }
  }
};
</script>

<style scoped lang="scss">
.patient-title {
  display: flex;
  justify-content: space-between;
  height: 48px;
  line-height: 48px;

  .title {
    font-size: 18px;
    font-weight: bold;
    color: #666666;
  }

}

.single-row {
  height: 56px;
  line-height: 56px;
  align-items: center;
}

.long-row {
  padding-top: 12px;
  padding-bottom: 12px;
}

.patient-method {
  display: flex;

  .key {
    width: 103px;
    font-size: 16px;
    color: #666666;
  }

  .value {
    flex: 1;
  }
}

.ill-level {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;

}

.confirm-button {
  margin-top: 12px;
  float: right;
  width: 64px;
  height: 32px;
  border-radius: 10px;
  padding-left: 18px;
  padding-top: 8px;
}
</style>
